import {
  Input,
  InputGroup,
  InputGroupProps,
  InputLeftAddon,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { invalidCharsUrl } from "../../utils/helperFunction";

interface Props extends InputGroupProps {
  inputValue?: string | undefined;
  onConfirm: (val: string) => void;
  name: string;
}

export const UrlInput = ({ name, inputValue, onConfirm, ...rest }: Props) => {
  const [data, setData] = useState<string>(inputValue?.toString() ?? "");

  useEffect(() => {
    inputValue ? setData(inputValue.toString()) : setData("");
  }, [inputValue]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData(e.target.value);
    onConfirm(e.target.value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (invalidCharsUrl.includes(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <InputGroup {...rest}>
      <InputLeftAddon>{`${process.env.REACT_APP_FRONTEND_URL}/`}</InputLeftAddon>

      <Input
        name={name}
        type="text"
        autoComplete="off"
        onChange={handleChange}
        value={data}
        onKeyDown={handleKeyDown}
      />
    </InputGroup>
  );
};
